/*
 * @Author: shannyHuang
 * @Date: 2022-03-17 18:05:24
 * @LastEditors: brucexlliu
 * @LastEditTime: 2022-10-25 16:51:37
 * @FilePath: \wemeet-web-activity\src\utils\activity-card-option.ts
 */
import {
  UpDateActivitySale,
  UpdateActivityTop,
  TopRequestParam,
  ImageRequestParams,
  getImageUrl,
  DeleteActivityRomte,
  PublishRequestParams,
  unPublishActivityRemote,
} from '../model/activity';
import {
  openPcMeetingDetailPage,
  openPcMeetingEditPage,
  openH5MeetingDetailPage,
  openCreateH5MeetingPage,
  LaunchWemeetAppMethod,
  openShareMobileModal,
} from './concat-meeting-util';
import { message } from '@tencent/tea-component';
import SaleModal from '../components/saleModal';
import MeetingErrorTips from '../components/ErrorTips';
import type { NextRouter } from 'next/router';
import { getBettweenAllDate } from './parse-date';
import { formatMeetingCode } from './format-meeting-code';
import { Activity } from '../model/type';
import { isWechatMiniProgram } from '@tencent/web-base';

const LOG_TAG = 'activity-card-option';
const SHARE_DEFAULT_IMG_URL =
  'https://cdn.calendar.tencent.com/calendar_res/activity/default_cover.jpeg';
/** pc方法 */
/** pc端跳转会议编辑详情 */
export const editPcMeeting = (id = '') => {
  if (!id) {
    console.error('editPcMeeting方法调用参数缺失');
    return;
  }
  openPcMeetingEditPage(id);
};
/** pc端查看详情 */
export const pcMeetingDetail = ({ role = 0, link = '', id = '' }) => {
  window.nextAegis?.infoAll(
    `pcMeetingDetail role: ${role}, meeting_id: ${id}, link:${link}`,
    LOG_TAG,
  );
  if (role !== 1 && link) {
    window.open(link, '_blank');
    return;
  }
  if (!id) {
    console.error('pcMeetingDetail方法调用参数缺失');
    return;
  }
  openPcMeetingDetailPage(id);
};

/** 1.0版本活动 pc 编辑*/

/** 端侧打开详情页 */
export const h5MeetingDetail = (id = '', router: NextRouter) => {
  window.nextAegis?.infoAll(
    `h5MeetingDetail click id:${id} ，router：${JSON.stringify(router)}`,
    LOG_TAG,
  );
  openH5MeetingDetailPage(id, router);
};
/** 端侧打开新建页 */
export const h5CreateMeeting = (router: NextRouter) => {
  openCreateH5MeetingPage(1, router);
};
/** 端侧打开报名页 */
export const openReport = (url: string) => {
  if (isWechatMiniProgram()) {
    const nextUrl = url.replace('/events-place', '');
    // 小程序内打开小程序报名页
    const mpRedirectUrl = `/registration/pages/registration/index?type=jump&targeturl=${encodeURIComponent(
      nextUrl,
    )}`;
    window.wx?.miniProgram?.navigateTo({
      url: mpRedirectUrl,
    });
    return;
  }
  LaunchWemeetAppMethod(url, {}, false);
};
/** 上下架 */
export const saleActivity = async (
  param: any,
  callBack: Function,
  isMobile = false,
  report?: Function,
) => {
  let loading = false;
  if (param?.is_on_sale === 0) {
    SaleModal.show({
      isMobile,
      className: isMobile ? 'activity-card-modal' : '',
      onConfirm: async () => {
        if (loading) return;
        loading = true;
        window.nextAegis?.infoAll(`SaleModal onConfirm click param:${param}`, LOG_TAG);
        report?.('1');
        const t = message.loading({ content: '请稍候...', duration: 0 });
        const status = await saleActivityRemote(param);
        window.nextAegis?.infoAll(
          `SaleModal onConfirm saleActivityRemote response ${status} `,
          LOG_TAG,
        );
        t.hide();
        callBack(status);
        loading = false;
      },
      onCancel: () => {
        loading = true;
        window.nextAegis?.infoAll('SaleModal onCancel', LOG_TAG);
        report?.('0');
        loading = false;
      },
    });
  } else {
    loading = true;
    const t = message.loading({ content: '请稍候...', duration: 0 });
    const status = await saleActivityRemote(param);
    t.hide();
    callBack(status);
    loading = false;
  }
};
/** 调用上下架接口 */
export const saleActivityRemote = async function (param: any) {
  return UpDateActivitySale(param).then(
    () => {
      message.success({ content: param?.is_on_sale === 0 ? '下架成功' : '上架成功' });
      return Promise.resolve({ code: 0 });
    },
    (err) => {
      message.error({ content: err || `${param?.is_on_sale === 0 ? '下架' : '上架'}接口调用失败` });
      return Promise.resolve({ code: -1 });
    },
  );
};
/** 1.0 删除活动 */
export const deleteActivity = async (
  param: { event_id?: string },
  callBack: Function,
  isMobile = false,
  report?: Function,
) => {
  let loading = false;
  if (!param?.event_id) return;
  SaleModal.show({
    title: '是否确认删除？',
    content: '当前活动尚未发布',
    cancelTxt: '取消',
    okTxt: '确认',
    isMobile,
    className: isMobile ? 'activity-card-modal' : '',
    onConfirm: async () => {
      if (loading) return;
      loading = true;
      window.nextAegis?.infoAll(`DeleteActivityModal onConfirm click param:${param}`, LOG_TAG);
      report?.('1');
      const t = message.loading({ content: '请稍候...', duration: 0 });
      DeleteActivityRomte(param).then(
        () => {
          message.success({ content: '删除成功' });
          const status = { code: 0 };
          window.nextAegis?.infoAll(
            `SaleModal onConfirm deleteActivity response ${status} `,
            LOG_TAG,
          );
          t.hide();
          callBack(status);
          loading = false;
        },
        (err) => {
          message.error({ content: '删除失败' });
          const status = { code: -1 };
          window.nextAegis?.infoAll(`SaleModal onConfirm deleteActivity response ${err} `, LOG_TAG);
          t.hide();
          callBack(status);
          loading = false;
        },
      );
    },
    onCancel: () => {
      loading = true;
      window.nextAegis?.infoAll('SaleModal deleteActivity onCancel', LOG_TAG);
      report?.('0');
      loading = false;
    },
  });
};
/** 撤销发布操作 */
export const unPublishActivity = function (
  param: PublishRequestParams,
  callBack: Function,
  isMobile = false,
  report?: Function,
  modalParams?: {
    title?: string;
    content?: string;
    successMsg?: string;
    errorMsg?: string;
    okTxt?: string;
    cancelTxt?: string;
  },
) {
  console.log('param', param);
  let loading = false;
  if (!param?.event_id) return;
  const {
    title = '是否确认取消发布',
    content = '您将放弃本次发布操作，活动恢复上次发布内容，是否取消',
    okTxt = '取消',
    cancelTxt = '再想想',
    successMsg = '取消发布成功',
  } = modalParams || {};
  SaleModal.show({
    title,
    content,
    isMobile,
    okTxt,
    cancelTxt,
    className: isMobile ? 'activity-card-modal' : '',
    onConfirm: async () => {
      if (loading) return;
      loading = true;
      window.nextAegis?.infoAll(`unPublishActivity onConfirm click param:${param}`, LOG_TAG);
      report?.('1');
      const t = message.loading({ content: '请稍候...', duration: 0 });
      unPublishActivityRemote(param).then(
        () => {
          message.success({ content: successMsg });
          const status = { code: 0 };
          window.nextAegis?.infoAll(
            `SaleModal onConfirm deleteActivity response ${status} `,
            LOG_TAG,
          );
          t.hide();
          callBack(status);
          loading = false;
        },
        (err) => {
          message.error({ content: err });
          const status = { code: -1 };
          window.nextAegis?.infoAll(`SaleModal onConfirm deleteActivity response ${err} `, LOG_TAG);
          t.hide();
          callBack(status);
          loading = false;
        },
      );
    },
    onCancel: () => {
      loading = true;
      window.nextAegis?.infoAll('SaleModal deleteActivity onCancel', LOG_TAG);
      report?.('0');
      loading = false;
    },
  });
};

/** 置顶 */
export const updateTopActivity = function (param: TopRequestParam) {
  const t = message.loading({ content: '请稍候...', duration: 0 });
  return UpdateActivityTop(param)
    .then(() => {
      t.hide();
      message.success({ content: `${!param?.is_on_top ? '取消置顶' : '置顶'}成功` });
      return Promise.resolve({ code: 0 });
    })
    .catch(() => {
      t.hide();
      return Promise.resolve({ code: -1 });
    });
};

/** 错误会议下架操作 */
export const errorMeeting = async (role: number, param = {}, callback: Function) => {
  window.nextAegis?.infoAll('errorMeeting tips show', LOG_TAG);
  MeetingErrorTips.show({
    role,
    onDelete: async () => {
      const t = message.loading({ content: '请稍候...', duration: 0 });
      window.nextAegis?.infoAll(
        `errorMeeting MeetingErrorTips onDelete param ${JSON.stringify(param)}`,
        LOG_TAG,
      );
      const status = await saleActivityRemote(param);
      t.hide();
      callback(status);
    },
  });
};

interface ShareActivity extends Activity {
  shareImageUrl?: string;
  hostName?: string;
}

export const returnShareObj = (shareOpt: ShareActivity) => {
  let desc = `会议时间：${getBettweenAllDate(shareOpt?.start_time, shareOpt?.end_time)}`;
  const onGoingStatus = shareOpt.meeting_status === 1 || shareOpt.event_status === 1;
  const beignStatus = shareOpt.meeting_status === 2 || shareOpt.event_status === 2;
  const endStatus = shareOpt.meeting_status === 0 || shareOpt.event_status === 0;
  if (onGoingStatus) desc = '活动已经开始，请尽快加入活动';
  if (endStatus) desc = '活动已结束，请点击查看详情或观看回放。';
  if (onGoingStatus || beignStatus)
    desc += `\r\n会议号：${formatMeetingCode(shareOpt?.meeting_code || '')}`;
  const opt = {
    title: shareOpt?.title || shareOpt?.meeting_title,
    desc,
    shareUrl: shareOpt?.short_link,
    imageUrl: shareOpt?.shareImageUrl || SHARE_DEFAULT_IMG_URL,
  };
  return opt;
};
export const returnShareEvent = (shareOpt: ShareActivity, registrationUrl = '') => {
  let desc = `活动时间：${getBettweenAllDate(shareOpt?.start_time, shareOpt?.end_time)}`;
  if (shareOpt.event_status === 2) desc += '\r\n点击查看活动详情';
  if (shareOpt.event_status === 1) desc += '\r\n活动进行中，尽快加入活动';
  if (shareOpt.event_status === 0) desc = '活动已结束，点击查看详情或观看回放。';
  const shareUrl = registrationUrl
    ? registrationUrl.replace('[eventId]', shareOpt?.event_id || '')
    : `${window.location.origin}/events/host/event/${shareOpt?.event_id}/registration`;
  const opt = {
    title: shareOpt?.title || '腾讯会议·活动',
    desc,
    shareUrl,
    imageUrl: shareOpt?.shareImageUrl || SHARE_DEFAULT_IMG_URL,
  };
  return opt;
};
/** 移动端分享操作 */
export const openMobileShareCard = (shareOpt: ShareActivity, registrationUrl = '') => {
  const opt =
    shareOpt?.event_type === -1
      ? returnShareObj(shareOpt)
      : returnShareEvent(shareOpt, registrationUrl);
  console.log('opt', opt);
  window.nextAegis?.infoAll(
    `openMobileShareCard shareActivity :${JSON.stringify(shareOpt)}, shareParam:${JSON.stringify(
      opt,
    )}`,
    LOG_TAG,
  );
  openShareMobileModal(opt);
};

/** 获取分享小图icon */
export const getMobileImage = async (param: ImageRequestParams) => {
  if (!param?.meeting_id) {
    return SHARE_DEFAULT_IMG_URL;
  }
  const res = await getImageUrl(param);
  window.nextAegis?.infoAll(
    `getMobileImage param :${JSON.stringify(param)}, res:${JSON.stringify(res)}`,
    LOG_TAG,
  );
  return res?.data?.cover_url || '';
};
